import { lazyLoad } from 'utils/loadable';

export const InvoiceDetailsPage = lazyLoad(
  () => import('./InvoiceDetailsPage/index'),
  module => module.InvoiceDetailsPage,
);
